<div class="card options-card">
  <div class="card-header bp-card-header">
    <i class="fas fa-file-alt  payment-options-icon"></i>
    <p class="font-weight-light bp-text">Letters and Forms</p>
  </div>
  <div class="card-body">
        <button class="btn btn-link btn-block clearfix accordion-btn">
          <!--<i *ngIf="!showPaperlessBilling" class="fas fa-angle-right fa-2x accordion-arrow"></i>
          <i *ngIf="showPaperlessBilling" class="fas fa-angle-down fa-2x accordion-arrow"></i>-->
          <div class="accordion-title-div pull-left font-weight-light bp-text bp-medium-text">Credit Letter</div>
        </button>
        <div class="container accordion-container">
          <div class="row">
            <div class="col-sm-4">
              <img style="width:23rem;" src="assets/credit-letter.png" />
            </div>
            <div class="col-sm-8">
              <p class="bp-text bp-small-text tall-p">
                A credit letter reflects your financial standing with us. The letter
                includes your name, service address and account information
                based on the past 24 months of service. (If you have not had a
                full 24 months of continuous service, the dates shown on your
                letter will coincide with your most recent service period.).
              </p>
            </div>
          </div>
          <div class="row">
            <input style="float:right;" class="btn btn-danger" type="button" value="CREATE LETTER">
          </div>
        </div>
        <button class="btn btn-link accordion-btn">
          <!--<i *ngIf="!showBudgetBilling" class="fas fa-angle-right fa-2x accordion-arrow"></i>
          <i *ngIf="showBudgetBilling" class="fas fa-angle-down fa-2x accordion-arrow"></i>-->
          <div class="accordion-title-div pull-left font-weight-light bp-text bp-medium-text">Letter of Residency</div>
        </button>

        <div class="container accordion-container">
          <div class="row">
            <div class="col-sm-4">
              <img style="width:23rem;" src="assets/credit-letter.png" />
            </div>
            <div class="col-sm-8">
              <p class="bp-text bp-small-text tall-p">
                A letter of residency establishes how long you have had service
                with us. The letter includes your name, service address, and
                dates of service to assist you in proving residency.
              </p>
            </div>
          </div>
          <div class="row">
            <input style="float:right;" class="btn btn-danger" type="button" value="CREATE LETTER">
          </div>
        </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/manage-letters/manage-letters.component.html